<template>
  <div class="collapseColumn-vueWrapper" id="list-filter">
    <div class="has-bg-white is-border" :class="{'is-padding-bottom!':hasMoreFilters}">
      <div class="columns is-vcentered is-gapless has-bg-light is-border-bottom">
        <div class="column is-padding-left">
          <div @click="collapseFilter" class="title is-5 has-cursor-pointer">
            <!--<span class="icon"><i class="fas fa-filter"></i></span>-->
            <span>Filtrage</span>
          </div>
        </div>
        <div class="column is-narrow has-text-right is-padding-top-small is-padding-bottom-small is-padding-right">
          <a @click="collapseFilter" class="is-pulled-right tooltip is-tooltip-left is-tooltip-primary js-collapse-left-column" data-tooltip="Fermer le volet">
            <i class="far fa-times has-text-grey"></i>
          </a>
        </div>
      </div>

      <div v-if="hasFilter && displayResetFilters" class="is-padding-left is-padding-top-xsmall is-padding-bottom-xsmall is-border-top has-bg-annonce">
        <a class="has-text-white is-size-6" @click.prevent.stop="resetFilters">
          <span class="icon"><i class="fas fa-undo"></i></span>
          <span class="is-italic">Réinitialiser tous les filtres</span>
        </a>
      </div>

      <div>
        <form @submit.prevent.stop="changeFilters()" @reset.prevent.stop="resetFilters">
          <div class="column is-paddingless-bottom is-padding-top-small" v-if="buttonLabel" id="filter-info">
            <div class="column is-radius has-text-white has-text-centered" :class="buttonClass" style="min-height: 54px;">
              <span v-if="!loading" v-html="buttonLabel"></span>
            </div>
          </div>
          <slot></slot>
          <div ref="moreCriteria" class="js-moreCriteria">
            <div class="is-border-top has-bg-primary" v-if="hasMoreCriterias">
              <a @click="showMoreCriteria = !showMoreCriteria; watchScroll(showMoreCriteria, 'moreCriteria', $event);" class="columns is-vcentered has-text-grey">
                <div class="column is-padding-left-large is-padding-top-xsmall is-padding-bottom-xsmall is-padding-right-xsmall is-narrow">
                  <span class="icon"><i class="fal" :class="showMoreCriteria ? 'fa-chevron-down' : 'fa-chevron-right'"></i></span>
                </div>
                <div class="column is-padding-xsmall has-text-white columns is-gapless is-vcentered">
                  <div class="column">
                    <span class="is-inline-flex-fullhd is-hidden-widescreen-only is-hidden-desktop-only is-hidden-tablet-only">Typologie&nbsp;<em>(plus de critères)</em></span><!-- Uniquement sur les grands écrans-->
                    <span class="is-hidden-fullhd">Typologie <em>(critères)</em></span>
                  </div>
                  <span class="column is-narrow is-margin-right-small" v-if="criteriasSelected">
                    <i class="fa fa-check-circle fa-lg has-text-white"></i>
                  </span>
                </div>
              </a>
            </div>
            <div class="has-bg-light">
              <slot name="more-criteria" v-if="showMoreCriteria"></slot>
            </div>
          </div>
          <div ref="moreFilters" class="js-moreFilters">
            <div class="is-border-top has-bg-light is-border-bottom" v-if="hasMoreFilters">
              <a @click="showMoreFilters = !showMoreFilters; watchScroll(showMoreFilters, 'moreFilters', $event);" class="columns is-vcentered has-text-grey">
                <div class="column is-padding-left-large is-padding-top-xsmall is-padding-bottom-xsmall is-padding-right-xsmall is-narrow">
                  <span class="icon has-text-grey-dark"><i class="fal" :class="showMoreFilters ? 'fa-chevron-down' : 'fa-chevron-right'"></i></span>
                </div>
                <div class="column is-padding-left-xsmall columns is-gapless is-vcentered">
                  <span class="column is-size-6 has-text-grey-dark has-text-weight-medium">{{moreFiltersLabel || 'Plus de filtres'}}</span>
                  <span class="column is-narrow" v-if="filtersSelected">
                    <i class="fa fa-check-circle fa-lg has-text-black"></i>
                  </span>
                </div>
              </a>
            </div>
            <div class="">
              <slot name="more-filters" v-if="showMoreFilters"></slot>
            </div>
          </div>
        </form>
      </div>
    </div>

    <div class="collapseColumn-openInfos is-padding" @click="collapseFilter">
      <div class="collapseColumn-openInfos-wrapper">
        <!--<a class="tooltip is-tooltip-bottom is-tooltip-primary" data-tooltip="Ouvrir" style="position:relative; z-index:2">
          <i class="fal fa-sliders-h has-text-grey"></i>
        </a>-->
        <a  class="has-badgeCustom--topright has-badgeCustom--out-quarter">
          <i class="fal fa-sliders-h has-text-grey"></i>
          <div v-if="hasFilter" class="badgeCustom is-smalll is-danger"><i class="fas fa-check"></i></div>
        </a>
        <div class="collapseColumn-openInfos-label">
          <span class="title is-5 has-text-grey is-uppercase">
            <!-- <span class="icon"><i class="fas fa-filter"></i></span>-->
            <span><b>Afficher filtres</b></span>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { debounce } from 'lodash'
  import { mapGetters } from 'vuex'
  import { bus, EVENTS } from '@/services/bus/index.js'

  export default {
    name: 'ListFilter',
    props: {
      hasFilter: {
        type: Boolean,
        default: false
      },
      loading: {
        type: Boolean,
        default: false
      },
      displayResetFilters: {
        type: Boolean,
        default: true
      },
      criteriasSelected: {
        type: [Boolean, Number],
        default: false
      },
      filtersSelected: {
        type: [Boolean, Number],
        default: false
      },
      actions: Array,
      label: String,
      buttonLabel: String,
      moreFiltersLabel: String,
      total: Number,
      bigTotal: Number
    },
    data () {
      return {
        showMoreFilters: false,
        showMoreCriteria: false
      }
    },
    computed: {
      ...mapGetters(['currentUserProfil']),
      availableActions () {
        let availableActions = []
        this.actions.forEach(a => {
          let display = true
          if (a.display && typeof a.display === 'function') {
            display = a.display(this.data)
          } else if (a.display === false) {
            display = a.display
          }
          if (display && (!a.needProfile || a.needProfile.includes(this.currentUserProfil))) {
            availableActions.push(a)
          }
        })
        return availableActions
      },
      labelPlurialize () {
        let s = this.label
        if (this.total > 1) {
          if (s[s.length - 1] === 'u') {
            s += 'x'
          } else if (s[s.length - 1] !== 'x' && s[s.length - 1] !== 's') {
            s += 's'
          }
        }
        return s
      },
      rightContent () {
        return this.$slots['right-content'][0]
      },
      hasMoreFilters () {
        return this.$slots['more-filters'] && this.$slots['more-filters'].length
      },
      hasMoreCriterias () {
        return this.$slots['more-criteria'] && this.$slots['more-criteria'].length
      },
      buttonClass () {
        if (!this.loading) {
          return 'is-padding-xsmall has-bg-primary'
        } else return 'button is-primary is-loading is-medium is-fullwidth'
      }
    },
    methods: {
      resetFilters (e) {
        this.$store.commit('setScrollEl', null)
        this.$emit('resetFilters')
      },
      changeFilters: debounce(function () {
        this.$emit('changeFilters')
      }, 300),
      collapseFilter () {
        if (this.loading) return
        this.$emit('opened')
        bus.$emit(EVENTS.RESIZE_TABLE)
      },
      watchScroll: function (value, target, event) {
        // console.log('watchScroll')
        if (!value) return false // Si c'est une fermeture des filtres on quitte

        Vue.nextTick(() => {
          setTimeout(() => {
            // Besoin de différer la gestion du scroll le temps que les éléments soient chargés avec leurs tailles définitive
            requestAnimationFrame(() => { this.actionsScroll(target) })
          }, 266)
        })
      },
      actionsScroll: function (cibleRef) {
      /*
        console.log('actionsScroll')
        console.log(this.$el.offsetHeight)
        console.log(this.$el.parentNode.offsetHeight)
        console.log(this.$refs[cibleRef].offsetHeight)
        console.log('this.$refs.moreCriteria.offsetTop ' + this.$refs[cibleRef].offsetTop) // offsetTop renvoie la distance entre l'élément courant et le haut du nœud offsetParent
        console.log('this.$refs.moreCriteria.parentNode.offsetTop ' + this.$refs[cibleRef].parentNode.offsetTop)
        console.log(this.$el.scrollTop)
        console.log(this.$el.parentNode.scrollTop)
      */

        // let w = window
        let el = this.$el
        let elParent = el.parentNode
        if (elParent) {
          // let posScroll = elParent.scrollTop
          let heightFilter = el.offsetHeight
          let heightFilterParent = elParent.offsetHeight
          let heightTarget = this.$refs[cibleRef].offsetHeight // Hauteur des filtres qui viennent d'être ouvert
          let posTargetFromTop = this.$refs[cibleRef].offsetTop + this.$refs[cibleRef].parentNode.parentNode.offsetTop
          let scroll = (posTargetFromTop + heightTarget - (heightFilterParent))
          scroll = (scroll < 0) ? 0 : scroll // Le scroll ne peut pas etre negatif
          scroll = (scroll > heightFilter) ? heightFilter : scroll // Le scrol ne peut pas etre superieur a la taille totale des filtres
          requestAnimationFrame(() => {
            // elParent.scroll(0, scroll)
            elParent.scrollTo({
              'behavior': 'smooth',
              'left': 0,
              'top': scroll
            })
          })
        }
      },
      posScroll: function (el) {
        return el.scrollTop // retourne la position du scroll de l'élément demandé
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/utils/ListFilter.vue